import { Toast } from 'antd-mobile'
import _ from 'lodash'
import currencyFormatter from 'currency-formatter'
import moment from 'moment'
import { Modal } from 'antd'
import { UAParser } from 'ua-parser-js'
import queryString from 'query-string'

import applePayRequest from 'utils/applePayRequest'
import googlePayRequest, { buildAllowedCardNetworks } from 'utils/googlePayRequest'
import { ALI_TOKEN_KEY } from './initAliFingerprint'
import samsungPayRequest from 'utils/samsungPayRequest'

moment.locale(getCurrentLanguage())

export function checkFormError(data, sort) {
  // check passed form errors, if this is no error, return true, else show the first error
  if (!data) {
    return true
  }
  var errors = _.chain(data).values().map('errors').flatten().value()
  if (sort) {
    errors = _.sortBy(errors, (x) => _.findIndex(sort, (y) => x.field === y))
  }
  const msg = _.get(errors, '[0].message')
  Toast.info(msg)
  return false
}

export function getUUID(length = 32) {
  return [...Array(length)]
    .map((i) => (~~(Math.random() * 36)).toString(36))
    .join('')
}

export function handleDate(date, formatter = 'DD-MM-YYYY HH:mm:ss') {
  return date ? moment(date).format(formatter) : ''
}

export function handleAmount(data, symbol, precision = 2) {
  const directions = ['-', '+', '']
  if (data) {
    const currency = symbol || data.currency
    const direction = data.direction || '2'
    return currencyFormatter.format(data.amount, {
      symbol: currency,
      precision: precision,
      format: currency
        ? `%s ${directions[direction]}%v`
        : `${directions[direction]}%v`, // %s is the symbol and %v is the value
    })
  }
  return '-.--'
}

// Visa installment "Monthly Rate" display:
// The installment APIs provide rate values that are shown as a monthly rate in UI.
// In practice (per product screenshots), values like 50 -> 0.5% and 150 -> 1.5%,
// meaning the backend is sending **basis points (bps)** for the monthly rate.
// If the backend sends a decimal, we treat it as an already-normalized percent.
export function yearlyRateToMonthlyPercent(rate) {
  if (rate === null || rate === undefined || rate === '') return 0
  const raw = Number(rate)
  if (!Number.isFinite(raw)) return 0

  // If it's an integer-like value, treat it as bps -> percent.
  // Examples: 50 => 0.5%, 150 => 1.5%
  const isIntLike = String(rate).indexOf('.') === -1
  return isIntLike ? raw / 100 : raw
}

export function getCurrentLanguage() {
  const supportLanguages = ['en', 'ar']
  const currentLanguage = sessionStorage.lang || localStorage.lang || window.navigator.language.split(/[-_]/)[0]
  return supportLanguages.indexOf(currentLanguage) > -1 ? currentLanguage : 'en'
}

export function setHtmlLangAndDir(language) {
  document.documentElement.setAttribute('lang', language)
  if (language === 'ar') {
    document.documentElement.setAttribute('dir', 'rtl')
    return 'rtl'
  } else {
    document.documentElement.removeAttribute('dir')
    return 'ltr'
  }
}

export function PayByInfo() {
  // PayBy/${PayBySDKVersion} (${hostAppName}, ${hostAppVersion}, ${IP}, ${mobileBrand})
  // 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_4_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 PayBy/1.5.1 (payby, 1.3.0, 192.168.1.4, iPhone 6)'
  const userAgent = navigator.userAgent
  if (userAgent.toLowerCase().indexOf('payby') === -1) {
    return {}
  }
  try {
    const PayBySDKVersion = userAgent.match(/PayBy\/([0-9.]+)/)[1]
    const infos = userAgent.match(/PayBy\/[0-9. ]+\(([^\\)]+)/)[1].split(',')
    return {
      PayBySDKVersion,
      hostAppName: infos[0].trim(' '),
      hostAppVersion: infos[1].trim(' '),
      IP: infos[2].trim(' '),
      mobileBrand: infos[3].trim(' '),
      lang: infos[4] && infos[4].trim(' '),
    }
  } catch (error) {
    return {}
  }
}

export function isPayBy() {
  // 判断是否在PayBy环境下
  return navigator.userAgent.toLowerCase().indexOf('payby') !== -1
}

export function isBOTIM() {
  // 判断是否在PayBy环境下
  return navigator.userAgent.toLowerCase().indexOf('botim') !== -1
}

export function openApp(url, brand = 'PayBy') {
  const links = {
    PayBy: 'https://app.payby.com/launch?feature-code=',
    ToTok: 'http://totok.ai/payby?feature-code=',
    BOTIM: 'https://botim.me/botim/payby?feature-code=',
  }
  window.location.href = links[brand] + encodeURIComponent(url)
}

export function deeplink(url, appName) {
  // 呼起deeplink, 3s没跳转就提示错误信息
  window.location.href = url
  const timer = setTimeout(() => {
    Modal.warning({
      icon: '',
      centered: true,
      content: `${appName} can't be opened, please check you had installed ${appName} correctly.`,
    })
  }, 3000)
  const visibilitychange = function() {
    const tag = document.hidden || document.webkitHidden
    tag && clearTimeout(timer)
  }
  document.addEventListener('visibilitychange', visibilitychange, false)
  document.addEventListener('webkitvisibilitychange', visibilitychange, false)
  window.addEventListener(
    'pagehide',
    function() {
      clearTimeout(timer)
    },
    false
  )
}

export function recordCountlyEvent(params) {
  // Countly埋点事件 http://wiki.test2pay.com/pages/viewpage.action?pageId=37302821
  const { query } = queryString.parseUrl(window.location.href)
  const campaignInfo = _.omitBy(query, (value, key) => !_.includes(key, 'utm_'))
  const { name, version } = new UAParser().getOS()
  console.log(params)
  /* eslint-disable camelcase */
  const { event_name = 'display', element_name = 'pageview' } = params
  window.Countly.q.push([
    'add_event',
    {
      key: event_name,
      segmentation: {
        event_name,
        element_name,
        ...params,
        event_time: new Date().getTime(),
        // user_id: localStorage.user_id,
        // 活动信息
        ...campaignInfo,
        // 系统信息
        os_platform: name,
        os_version: version,
        [ALI_TOKEN_KEY]: sessionStorage.getItem(ALI_TOKEN_KEY),
      }
    }
  ])
}

export function postMessage({ status, ...data }) {
  const message = {
    message: 'PayBy_Messages',
    status,
    data,
  }
  window.parent.postMessage(message, '*')
}

export function changeTheme(model) {
  // model=LIGHT_DARK不设置data-theme
  const root = document.documentElement
  if (model !== 'LIGHT_DARK') {
    root.setAttribute('data-theme', model.toLowerCase())
  } else {
    root.removeAttribute('data-theme')
  }
}

export function getTheme() {
  return (
    document.documentElement.getAttribute('data-theme') ||
    (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
  )
}

export function setThemeVariables(themeVariables) {
  // 根据商户传入的主题参数改变css变量
  if (themeVariables) {
    const {
      font,
      model,
      primaryColorLight,
      secondaryColorLight,
      primaryColorDark,
      secondaryColorDark
    } = themeVariables

    changeTheme(model)

    const setPrimaryColor = function(isDarkMode) {
      // 深色模式model=LIGHT_DARK || model=DARK 设置*ColorDark
      const isDark = model === 'DARK' || (model === 'LIGHT_DARK' && isDarkMode)
      const primaryColor = isDark ? primaryColorDark : primaryColorLight
      const secondaryColor = isDark ? secondaryColorDark : secondaryColorLight
      console.log(primaryColor)

      if (primaryColor) {
        const hsl = hexToHSL(primaryColor)
        document.documentElement.style.setProperty('--primary_default', primaryColor)
        document.documentElement.style.setProperty(
          '--root-primary-color-h',
          hsl.h.toString()
        )
        document.documentElement.style.setProperty(
          '--root-primary-color-l',
          hsl.l * 100 + '%'
        )
        document.documentElement.style.setProperty(
          '--root-primary-color-s',
          hsl.s * 100 + '%'
        )
      }

      if (secondaryColor) {
        document.documentElement.style.setProperty(
          '--primary_color_secondary',
          secondaryColor
        )
      }
    }

    // 判断是否匹配深色模式
    const darkMode =
      window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)')
    setPrimaryColor(darkMode.matches)
    // 监听主题切换事件
    model === 'LIGHT_DARK' && darkMode &&
      darkMode.addEventListener('change', (e) => {
        setPrimaryColor(e.matches)
      })

    if (
      font &&
      document.documentElement.style.getPropertyValue('--font_family') !== font
    ) {
      const link = document.createElement('link')
      link.setAttribute('rel', 'stylesheet')
      link.setAttribute('href', `https://fonts.googleapis.com/css?family=${font}`)
      document.body.appendChild(link)
      document.documentElement.style.setProperty('--font_family', font)
    }
  }
}

export function hexToHSL(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  let r = parseInt(result[1], 16)
  let g = parseInt(result[2], 16)
  let b = parseInt(result[3], 16)
  r /= 255
  g /= 255
  b /= 255
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  let h
  let s
  const l = (max + min) / 2
  // eslint-disable-next-line eqeqeq
  if (max == min) {
    h = s = 0 // achromatic
  } else {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      case b:
        h = (r - g) / d + 4
        break
    }
    h /= 6
  }
  h = Math.round(h * 360)
  // s = Math.round(s * 100)
  // l = Math.round(l * 100)
  const HSL = {}
  HSL.h = h
  HSL.s = s
  HSL.l = l
  return HSL
}

export const devicePay = {
  filter: async function(payTabs) {
    if (_.find(payTabs, { tabName: 'Apple Pay', tabType: 'DEVICE_PAY' })) {
      try {
        const isSupportApplePay = applePayRequest.canMakePayments()
        !isSupportApplePay &&
          _.remove(payTabs, {
            tabName: 'Apple Pay',
            tabType: 'DEVICE_PAY',
          })
      } catch (error) {
        _.remove(payTabs, {
          tabName: 'Apple Pay',
          tabType: 'DEVICE_PAY',
        })
      }
    }
    const googlePayTab = _.find(payTabs, { tabName: 'Google Pay', tabType: 'DEVICE_PAY' })
    if (googlePayTab) {
      try {
        // 按商户允许的卡组织检查（和拉起面板时一致）；allowCardBrands 没有 Google 支持的卡组织时
        // （configError）按全量检查，标签保留，由点击时的提示说明原因；extension 为 null 已由 helper 兜底
        let allowedCardNetworks
        try {
          allowedCardNetworks = buildAllowedCardNetworks(_.get(googlePayTab, 'payMethod.payMethodExtension'))
        } catch (configError) {
          allowedCardNetworks = undefined
        }
        const isSupportGooglePay = await googlePayRequest.isReadyToPay(allowedCardNetworks)
        !isSupportGooglePay &&
          _.remove(payTabs, {
            tabName: 'Google Pay',
            tabType: 'DEVICE_PAY',
          })
      } catch (error) {
        _.remove(payTabs, {
          tabName: 'Google Pay',
          tabType: 'DEVICE_PAY',
        })
      }
    }
    if (_.find(payTabs, { tabName: 'Samsung Pay', tabType: 'DEVICE_PAY' })) {
      const isPC = /Windows|Macintosh|Linux/.test(navigator.userAgent)
      try {
        // On PC, always show Samsung Pay; on mobile, check isReadyToPay
        var isSupportSamsungPay = isPC ? true : await samsungPayRequest.isReadyToPay()
        !isSupportSamsungPay &&
          _.remove(payTabs, {
            tabName: 'Samsung Pay',
            tabType: 'DEVICE_PAY'
          })
      } catch (error) {
        _.remove(payTabs, {
          tabName: 'Samsung Pay',
          tabType: 'DEVICE_PAY'
        })
      }
    }
    return payTabs
  },
  preferred: function() {
    const ua = new UAParser()
    switch (ua.getOS().name) {
      case 'iOS':
      case 'Mac OS':
        if (['Safari', 'Mobile Safari'].indexOf(ua.getBrowser().name) > -1) {
          return {
            tabName: 'Apple Pay',
            tabType: 'DEVICE_PAY',
          }
        } else {
          return {
            tabName: 'Google Pay',
            tabType: 'DEVICE_PAY',
          }
        }
      case 'Android':
        // if (ua.getDevice().vendor === 'Samsung') {
        //   return {
        //     tabName: 'Samsung Pay',
        //     tabType: 'DEVICE_PAY',
        //   }
        // } else {
        return {
          tabName: 'Google Pay',
          tabType: 'DEVICE_PAY',
        }
        // }
      default:
        return {
          tabName: 'Google Pay',
          tabType: 'DEVICE_PAY',
        }
    }
  }
}

export { default as intl } from './intl'
